// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'

Vue.use(element)

import PortraitLabels from "./components/PortraitLabels.vue";
Vue.component("portraitLabels",PortraitLabels);

import FoldModule from "./components/FoldModule.vue";
Vue.component("foldModule",FoldModule);

import TalentPortrait from './components/TalentPortrait.vue';
import eventBus from "../../../../../../util/eventBus";


(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            // updateHtml(this.model, props)
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.invoke = (eventName, args)=>{
                invoke(eventName, args)
            }
            new Vue({
                el: model.dom,
                template: '<TalentPortrait  :themeNum="themeNum" :lang="lang" :cusParam_portraitData="cusParam_portraitData" />',
                components: {
                    TalentPortrait
                },
                data: {
                    themeNum:"#5582F3",
                    lang:"zh_CN",
                    cusParam_portraitData:null,
                },
                destoryed() {
                    console.log('`')
                },
                mounted() {
                    if(props.themeNum){this.themeNum = props.themeNum;}
                    if(props.lang){this.lang = props.lang;}
                    if(props.data && props.data.hasOwnProperty('cusParam_portraitData') && props.data.cusParam_portraitData){
                        this.cusParam_portraitData = props.data.cusParam_portraitData ? JSON.parse(props.data.cusParam_portraitData) : [];
                    }
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        if(props.themeNum){this.themeNum = props.themeNum;}
                        if(!props.data){return}
                    if(props.data && props.data.hasOwnProperty('cusParam_portraitData') && props.data.cusParam_portraitData){
                        this.cusParam_portraitData = props.data.cusParam_portraitData ? JSON.parse(props.data.cusParam_portraitData) : [];
                    }
                    })
                },
                methods: {

                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('talentPortrait', MyComponent,{
        isMulLang: true
    })
})(window.KDApi)
